import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from '@/shared/api';
import { CONFLICT_STATUS_CODE } from '@/shared/api/errors';
import { isErrorGuard } from '@/shared/lib/types';
import { GTMEvents, MixpanelEvents, setMixpanelUser } from '@/shared/thirdParty';

import { LS_IS_JUST_SIGNED_IN_NAME } from '../lib/constants';
import { USER_QUERY_KEYS } from '../lib/userQueryKeys';

type CreateUserParams = {
  isSocial?: boolean;
  onError?: () => void;
};

export const useCreateUser = ({ isSocial = false }: CreateUserParams) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: API.createUser,
    onError: async (error) => {
      if (isErrorGuard(error, CONFLICT_STATUS_CODE)) {
        await queryClient.refetchQueries({ queryKey: USER_QUERY_KEYS.userData, type: 'active' });
      }
    },
    onSuccess: async (newUser) => {
      await queryClient.refetchQueries({ queryKey: USER_QUERY_KEYS.userData, type: 'active' });

      setMixpanelUser(newUser.id, newUser.email, newUser.email_type);
      MixpanelEvents.signUp({ isSocial });
      GTMEvents.setUserId(newUser.id);
      GTMEvents.registration();
      // remove this LS item to prevent sending 'login' event after 'registration'
      localStorage.removeItem(LS_IS_JUST_SIGNED_IN_NAME);
    },
  });
};
